import { __ } from "@wordpress/i18n";
import React from "react";
import { FacebookIcon, InstagramIcon, YoutubeIcon, TwitterIcon, ReviewIcon,
    InstagramFauxPreview, FacebookFauxPreview, TwitterFauxPreview, YoutubeFauxPreview,
    ReviewFauxPreview, 
    ReviewLogo} from "../icons";

const fauxBlocks = [
    {
        id: 'instagram',
        name: 'smashballoon/instagram-feed-faux',
        title: __('Instagram Feed', 'sb-common'),
        icon: 'instagram',
        description: __('Select and display any of your Instagram feeds.', 'sb-common'),
        contentDesc: __('Custom Instagram Feeds is a highly customizable way to display feeds from your Instagram account. Promote your latest content and update your site content automatically.', 'sb-common'),
        downloadLink: 'https://downloads.wordpress.org/plugin/instagram-feed.zip',
        logo: <InstagramIcon />,
        preview: <InstagramFauxPreview />,
    },
    {
        id: 'facebook',
        name: 'smashballoon/facebook-feed-faux',
        title: __('Facebook Feed', 'sb-common'),
        icon: 'facebook',
        description: __('Select and display any of your Facebook feeds.', 'sb-common'),
        contentDesc: __('Custom Facebook Feeds is a highly customizable way to display feeds from your Facebook page. Promote your latest content and update your site content automatically.', 'sb-common'),
        downloadLink: 'https://downloads.wordpress.org/plugin/custom-facebook-feed.zip',
        logo: <FacebookIcon />,
        preview: <FacebookFauxPreview />,
    },
    {
        id: 'youtube',
        name: 'smashballoon/youtube-feed-faux',
        title: __('YouTube Feed', 'sb-common'),
        icon: 'youtube',
        description: __('Select and display any of your Youtube feeds.', 'sb-common'),
        contentDesc: __('YouTube Feeds is a highly customizable way to display feeds from your YouTube channel. Promote your latest content and update your site content automatically.', 'sb-common'),
        downloadLink: 'https://downloads.wordpress.org/plugin/feeds-for-youtube.zip',
        logo: <YoutubeIcon />,
        preview: <YoutubeFauxPreview />,
    },
    {
        id: 'twitter',
        name: 'smashballoon/twitter-feed-faux',
        title: __('Twitter Feed', 'sb-common'),
        icon: 'twitter',
        description: __('Select and display any of your Twitter feeds.', 'sb-common'),
        contentDesc: __('Custom Twitter Feeds is a highly customizable way to display tweets from your Twitter account. Promote your latest content and update your site content automatically.', 'sb-common'),
        downloadLink: 'https://downloads.wordpress.org/plugin/custom-twitter-feeds.zip',
        logo: <TwitterIcon />,
        preview: <TwitterFauxPreview />,
    },
    {
        id: 'reviews',
        name: 'smashballoon/reviews-feed-faux',
        title: __('Reviews Feed', 'sb-common'),
        icon: <ReviewLogo />,
        description: __('Select and display any of your Reviews feeds.', 'sb-common'),
        contentDesc: __('Reviews Feeds is a highly customizable way to display reviews from Google or Yelp. Promote your latest content and update your site content automatically.', 'sb-common'),
        downloadLink: 'https://downloads.wordpress.org/plugin/reviews-feed.zip',
        logo: <ReviewIcon />,
        preview: <ReviewFauxPreview />,
    }
];

export {fauxBlocks};
